'use client';

import {useEffect} from 'react';
import Image from 'next/image';
import Link from 'next/link';
import errorImage from '@/public/static/assets/error.jpg';
import {buttonClass} from '@/components/Button';
import {track} from '@/lib/analytics';

// Error boundaries must be Client Components, so this one avoids server-only parts (Footer, Sanity).
const ErrorPage = ({error, reset}: {error: Error & {digest?: string}; reset: () => void}) => {
  useEffect(() => {
    track('app_error', {digest: error.digest ?? 'client'});
  }, [error.digest]);
  return (
  <main className='relative isolate flex min-h-[calc(100svh-var(--header-height))] items-end overflow-hidden bg-zinc-900'>
    <Image src={errorImage} alt='' fill priority sizes='100vw' placeholder='blur' className='-z-10 object-cover' />
    <div className='absolute inset-0 -z-10 bg-gradient-to-t from-black/80 via-black/40 to-black/10' aria-hidden />
    <div className='container-site pt-20 pb-16'>
      <p className='mb-4 text-sm font-semibold tracking-wider text-brand-300 uppercase'>Fehler</p>
      <h1 className='text-4xl font-bold tracking-tight text-white sm:text-5xl'>Da ist etwas schiefgelaufen</h1>
      <p className='mt-5 max-w-xl text-lg text-zinc-200'>Es ist ein unerwarteter Fehler aufgetreten.</p>
      <div className='mt-8 flex flex-wrap gap-3'>
        <button type='button' onClick={reset} className={`${buttonClass('primary')} cursor-pointer`}>
          Erneut versuchen
        </button>
        <Link href='/' className={buttonClass('outline-light')}>
          Zur Startseite
        </Link>
      </div>
    </div>
  </main>
  );
};

export default ErrorPage;
